// extracted by mini-css-extract-plugin
module.exports = {"TabContainer":"AccountsManagement_TabContainer__2bfu7"};